/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * First name
     * @type {string}
     * @memberof UpdateUserDto
     */
    'firstName'?: string;
    /**
     * Middle name
     * @type {string}
     * @memberof UpdateUserDto
     */
    'middleName'?: string;
    /**
     * Last name
     * @type {string}
     * @memberof UpdateUserDto
     */
    'lastName'?: string;
    /**
     * Nickname
     * @type {string}
     * @memberof UpdateUserDto
     */
    'nickName'?: string;
    /**
     * Birth date
     * @type {string}
     * @memberof UpdateUserDto
     */
    'birthDate'?: string;
    /**
     * Mobile number
     * @type {string}
     * @memberof UpdateUserDto
     */
    'mobileNumber'?: string;
    /**
     * Profile photo URL
     * @type {string}
     * @memberof UpdateUserDto
     */
    'profilePhotoUrl'?: string;
    /**
     * Whether user has completed onboarding
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'hasOnboarded'?: boolean;
    /**
     * Firebase Cloud Messaging tokens for push notifications
     * @type {Array<string>}
     * @memberof UpdateUserDto
     */
    'fcmTokens'?: Array<string>;
    /**
     * Login method used by the user
     * @type {string}
     * @memberof UpdateUserDto
     */
    'loginMethod'?: string;
    /**
     * Current status of the user account
     * @type {string}
     * @memberof UpdateUserDto
     */
    'status'?: UpdateUserDtoStatusEnum;
}

export const UpdateUserDtoStatusEnum = {
    Active: 'active',
    Inactive: 'inactive',
    Deleted: 'deleted'
} as const;

export type UpdateUserDtoStatusEnum = typeof UpdateUserDtoStatusEnum[keyof typeof UpdateUserDtoStatusEnum];


